import React from "react";
import { CompanySettings } from "../../domain/entities/CompanySettings";
import { SettingsSectionConfig } from "../config/companyDetailsForm";
import { SettingsField } from "./SettingsField";

interface SettingsSectionProps {
  config: SettingsSectionConfig;
  settings: CompanySettings;
  values: Record<string, string>;
  fieldErrors: Record<string, string>;
  onChange: (field: string, value: string) => void;
}

/** One titled group of fields inside a settings panel. */
export const SettingsSection: React.FC<SettingsSectionProps> = ({
  config,
  settings,
  values,
  fieldErrors,
  onChange,
}) => (
  <section className="flex w-full flex-col gap-4 border-b border-solid border-neutral-border pb-8 last:border-b-0 last:pb-0">
    <div className="flex flex-col gap-1">
      <span className="text-heading-3 font-heading-3 text-default-font">{config.title}</span>
      {config.description && (
        <span className="text-body font-body text-subtext-color">{config.description}</span>
      )}
    </div>

    <div className="grid w-full grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-2">
      {config.fields.map((field) => (
        <div
          key={field.name}
          // Long-form answers read badly at half width.
          className={field.kind === "textarea" ? "md:col-span-2" : undefined}
        >
          <SettingsField
            config={field}
            settings={settings}
            value={values[field.name] ?? ""}
            errorMessage={fieldErrors[field.name] ?? null}
            onChange={onChange}
          />
        </div>
      ))}
    </div>
  </section>
);
